// Shown when a user is authenticated via Okta but does not yet have an
// employee record in the portal. Happens when IT has provisioned the user in
// Okta but People Operations hasn't added them in the People & Access tab.
import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

export const ProfileNotFound = () => {
  const { oktaAuth } = useOktaAuth();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#1e1e23', fontFamily: 'var(--font-sans)' }}>
      <div style={{ maxWidth: 420, textAlign: 'center', padding: '2rem' }}>
        <img src="/logo-full.png" alt="xLight" style={{ height: 56, width: 'auto', marginBottom: 32 }} />
        <h2 style={{ fontSize: 18, fontWeight: 400, color: '#fff', marginBottom: 10, letterSpacing: '0.02em' }}>
          Your profile is being set up
        </h2>
        <p style={{ fontSize: 13, color: '#8888aa', lineHeight: 1.7, marginBottom: 28 }}>
          You have successfully logged in but your portal profile is not yet active.
          People Operations will complete your setup shortly and you will receive
          an email when your portal is ready.
        </p>
        <p style={{ fontSize: 12, color: '#444466', marginBottom: 24 }}>
          If you believe this is an error, please contact People Operations.
        </p>
        <button
          onClick={() => oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + '/login' })}
          style={{ fontSize: 12, letterSpacing: '0.06em', padding: '9px 24px', borderRadius: 6, border: '0.5px solid #2e2850', background: 'transparent', color: '#8888aa', cursor: 'pointer' }}>
          SIGN OUT
        </button>
      </div>
    </div>
  );
};

export default ProfileNotFound;
